/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';
import { useIntl } from 'react-intl';

export const ForecastSeparatorLabel: FC = ({ viewBox, fill, isHorizontal }: any) => {
  const intl = useIntl();
  const textX = viewBox.x + viewBox.width - 10;
  const textY = viewBox.y;

  return (
    <text
      x={textX}
      y={textY}
      textAnchor="middle"
      dominantBaseline="middle"
      transform={isHorizontal ? `translate(0, 4) rotate(90, ${textX}, ${textY})` : 'translate(14, -4)'}
      fill={fill}
      fontSize={8}
      fontWeight={500}
      fontFamily="SageUI"
    >
      {intl.formatMessage({ id: 'reporting.actuals', defaultMessage: 'Actuals' })} &nbsp;{' '}
      {intl.formatMessage({ id: 'reporting.forecasts', defaultMessage: 'Forecasts' })}
    </text>
  );
};
